import turbolinksLoadedObservable from '@newswebsiteapp/shared/observables/turbolinksLoadedObservable'

turbolinksLoadedObservable.subscribe(() => {
  if (window.crs) {
    window.crs.init()
  }
})
